import { _ as __assign } from '../../chunks/bundle-j5GfJ6DZ.js';
import React__default from 'react';
import { M as MessageInputWrapperView } from '../../chunks/bundle-B1Tn6-pu.js';
export { V as VoiceMessageInputWrapper } from '../../chunks/bundle-B1Tn6-pu.js';
import { u as useGroupChannel } from '../../chunks/bundle-BykuFiQC.js';
import '../../chunks/bundle-44j0QAmj.js';
import '../../chunks/bundle-CPQL3IZE.js';
import '../../chunks/bundle-BSUtC3cw.js';
import '../../chunks/bundle-BjDPDV1u.js';
import '../../chunks/bundle-CnQtgeX8.js';
import './SuggestedMentionList.js';
import '../../chunks/bundle-B5EHFFGW.js';
import '../../chunks/bundle-ZBp236Ey.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-idC_wVZi.js';
import '../../chunks/bundle-2OseAMr7.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-BlgLvEI8.js';
import '../../chunks/bundle-B7LMd75S.js';
import '../../chunks/bundle-dyq0aH11.js';
import '../../chunks/bundle-DloqDvm2.js';
import '../../chunks/bundle-BC1GKYVu.js';
import '../../chunks/bundle-C6g3HNED.js';
import '@sendbird/chat';
import '@sendbird/chat/groupChannel';
import '@sendbird/chat/openChannel';
import '../../Message/hooks/useDirtyGetMentions.js';
import '../../ui/QuoteMessageInput.js';
import '../../chunks/bundle-EMEHizdG.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-Bzoj1u3h.js';
import '../../chunks/bundle-Cj_4CfJM.js';
import '../../chunks/bundle-RVsnVYbw.js';
import '../../chunks/bundle-7yeG72vW.js';
import '../../VoicePlayer/useVoicePlayer.js';
import '../../chunks/bundle-0nLnxiJ2.js';
import '../../VoiceRecorder/context.js';
import '../../chunks/bundle-B4W1Qw_4.js';
import 'react-dom';
import '../../chunks/bundle-DvCKSiBl.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../VoiceRecorder/useVoiceRecorder.js';
import '../../chunks/bundle-pTFXff0f.js';
import '../../ui/PlaybackTime.js';
import '../../ui/ProgressBar.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-CyIWMcD_.js';
import '../../ui/MessageInput.js';
import '../../chunks/bundle-DRAooF75.js';
import 'dompurify';
import '../../chunks/bundle-CGAxlcUv.js';
import '../../chunks/bundle-xdZcjYxt.js';
import '../../chunks/bundle-DEv-umdP.js';
import '../../chunks/bundle-CSKhnQl7.js';
import '../../hooks/useModal.js';
import '../../chunks/bundle-X0vBfD3T.js';
import '@sendbird/chat/message';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-S7XE7Lfi.js';
import '../../chunks/bundle-BSLHBsOu.js';
import '../../chunks/bundle-CHW7NXXK.js';
import '../../chunks/bundle--h0f5LUC.js';
import '../../chunks/bundle-u2dy86rx.js';
import '../../chunks/bundle-CxpAk_cb.js';

var MessageInputWrapper = function (props) {
    var _a = useGroupChannel(), state = _a.state, actions = _a.actions;
    return React__default.createElement(MessageInputWrapperView, __assign({}, props, state, actions));
};

export { MessageInputWrapper, MessageInputWrapper as default };
//# sourceMappingURL=MessageInputWrapper.js.map
